import { limit, orderBy, query, where } from 'firebase/firestore'
import { ArrayService } from './serviceLive'
import type { Parcel } from '~/models'

const parcelStatusesOpen = [
  'created',
  'checkPackage',
  'readyForSend',
  'notCompleteDelay',
  'prescriptionDelay',
  'tempDelay',
  'longDelay',
  'delayed',
  'sendLater',
  'controlCompleted',
]

export class ParcelService extends ArrayService<Parcel> {
  constructor() {
    super('Parcels')
  }

  public listenForLatestParcelOfUser(userId: string): void {
    const listenQuery = query(
      this.collection,
      where('UserId', '==', userId),
      orderBy('Created', 'desc'),
      limit(1),
    )

    this.listen(listenQuery)
  }

  public listenForId(userId: string): void {
    const listenQuery = query(
      this.collection,
      where('UserId', '==', userId),
      where('CurrentStatus', 'in', parcelStatusesOpen),
      orderBy('Created', 'desc'),
    )
    this.listen(listenQuery)
  }

  public listenForBundleId(bundleId: string): void {
    const listenQuery = query(
      this.collection,
      where('BundleIds', 'array-contains', bundleId),
      where('CurrentStatus', 'in', parcelStatusesOpen),
    )
    this.listen(listenQuery)
  }
}
